export default class CommandsController {
  _requestService;
  _paths;

  constructor(requestService, paths) {
    this._requestService = requestService;
    this._paths = paths;
  }

  async createNewPlanRequest({
    where_place,
    what_activities,
    how_remember,
    daysTime,
    whenCheckDays,
    extra_data,
    child,
    module,
  }) {
    let params = {
      where_place,
      what_activities,
      how_remember,
      daysTime,
      whenCheckDays,
      extra_data,
      child,
      module,
    };
    if (params.extra_data === '') {
      delete params.extra_data;
    }
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.CREATE_PLAN_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async editPlanRequest({
    where_place,
    what_activities,
    how_remember,
    daysTime,
    whenCheckDays,
    extra_data,
    child,
    module,
    planId,
    parentEdit,
  }) {
    let params = {
      where_place,
      what_activities,
      how_remember,
      daysTime,
      whenCheckDays,
      extra_data_how_remember: extra_data,
      child,
      module,
      parentEdit: parentEdit,
    };
    if (params.extra_data_how_remember === '') {
      delete params.extra_data_how_remember;
    }
    return new Promise((resolve, reject) => {
      this._requestService
        .Put(this._paths.EDIT_PLAN_PATH(planId), params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async addChildCriteria({ module, child, items, parent }) {
    let params = {
      module,
      child,
      items,
      parent,
    };
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.CHECKLIST_CREATION_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async createCriterionRequest({ module, childId, description, userId, value, tag }) {
    let params = {
      module,
      child: childId,
      description,
      user: userId,
      value,
    };
    if (tag) {
      params.tag = tag
    }
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.CREATE_CRITERION_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateCriterionRequest({ itemId, name, coin_value }) {
    let params = {
      description: name,
      value: coin_value,
    };
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.UPDATE_CRITERIA_PATH(itemId), params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async deleteCriterion({ criterionId }) {
    return new Promise((resolve, reject) => {
      this._requestService
        .Delete(this._paths.CHECKLIST_ITEM_PATH(criterionId))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async childApproveCriterionRequest({ items, date }) {
    let params = { items, date };
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.CHILD_CHECKLIST_VALUATE_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async parentApproveCriterionRequest({ items, date, child }) {
    let params = { items, date, child };
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.PARENT_CHECKLIST_VALUATE_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async acceptOrRejectItemChecklist({ id, child, value }) {
    const path = this._paths.ACCEPT_OR_REJECT_CHECKLIST(id);
    const params = { child, value };
    return await this._requestService.Post(path, params);
  }

  async editItemOrder({ childId, dataItem }) {
    try {
      const path = this._paths.CHANGE_ITEM_ORDER(childId);
      const { data } = await this._requestService.Post(path, dataItem);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not edit item index');
    }
  }

}
